module.exports = __webpack_public_path__ + "img/lab.1cf22613.png";